import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatCard, MatCardContent} from "@angular/material/card";
import {TournamentService} from "../../service/tournament.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Tournament} from "../../model/tournament";
import {Round} from "../../model/round";
import {TeamPipe} from "../../pipes/team-pipe";
import {FullNamePipe} from "../../pipes/fullname-pipe";
import {Group} from "../../model/group";
import {MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {HeaderService} from "../../service/header.service";
import {TeamDisplayComponent} from "../team-display/team-display.component";
import {Event} from "../../model/event";

@Component({
  selector: 'app-match-sheets',
  imports: [
    MatCard,
    MatCardContent,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    TeamDisplayComponent
  ],
  providers: [
    TeamPipe,
    FullNamePipe
  ],
  templateUrl: './match-sheets.component.html',
  standalone: true,
  styleUrl: './match-sheets.component.scss'
})
export class MatchSheetsComponent implements OnInit, OnDestroy {

  tournament: Tournament;
  event: Event;
  group: Group;
  round: Round;

  constructor(
    private tournamentService: TournamentService,
    private route: ActivatedRoute,
    private router: Router,
    private headerService: HeaderService
  ) {
  }

  ngOnInit() {
    const tournamentId = this.route.snapshot.paramMap.get('id');
    let roundId = Number(this.route.snapshot.paramMap.get('roundId'));

    this.tournamentService.getById(Number(tournamentId)).subscribe(data => {
      this.tournament = data;
      for (let event of this.tournament.events) {
        for (let group of event.groups) {
          for (let round of group.rounds) {
            if (round.id == roundId) {
              this.event = event;
              this.group = group;
              this.round = round;
              this.headerService.setTitle(`Wedstrijdbriefjes ${this.group.name} ${this.round.name}`);
              return;
            }
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.headerService.clearTitle()
  }

}
